import { createFromIconfontCN } from '@ant-design/icons';
import './index.scss';

const IconFont = createFromIconfontCN({
  scriptUrl: ['//akoss.bangcdn.net/fe/iconfont_20250527.js'],
});
export default IconFont;
